import { Flex, Image, Link } from '@chakra-ui/core';
import React from 'react';
import LogoImage from '../assets/logo.png';

const Header = (props) => {
  const { children, ...rest } = props;

  return (
    <Flex
      as="nav"
      align="center"
      justify="center"
      wrap="wrap"
      padding="1rem"
      bg="white"
      backgroundColor="#42486b"
      position="relative"
      // borderBottom="1px solid"
      // borderBottomColor="gray.500"
      // color="white"
      {...rest}
    >
      <Link
        href="https://atomic.finance/odds"
        target="_blank"
        position="absolute"
        top={6}
        left={6}
      >
        <Image src={LogoImage} w="150px" />
      </Link>
      {children}
    </Flex>
  );
};

export default Header;
